import React from 'react'
import { useCart } from '../context/CartContext'

const Header = ({ onCartClick }) => {
 const { getCartItemsCount } = useCart()

 return (
 <header style={{
 background: 'rgba(255,255,255,0.95)',
 backdropFilter: 'blur(10px)',
 borderBottom: '1px solid rgba(255,107,139,0.1)',
 position: 'sticky',
 top:0,
 zIndex:1000 }}>
 <div className="container">
 <div style={{
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'space-between',
 padding: '16px 0'
 }}>
 <div style={{
 display: 'flex',
 alignItems: 'center',
 gap: '8px'
 }}>
 <div style={{
 width: '32px',
 height: '32px',
 background: 'linear-gradient(135deg, #ff6b8b, #8b5cf6)',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 color: 'white',
 fontWeight: 'bold',
 fontSize: '14px'
 }}>
甜 </div>
 <span style={{
 fontSize: '1.5rem',
 fontWeight: '700',
 background: 'linear-gradient(135deg, #ff6b8b, #8b5cf6)',
 WebkitBackgroundClip: 'text',
 WebkitTextFillColor: 'transparent',
 backgroundClip: 'text'
 }}>
甜蜜时光 </span>
 </div>

 <nav style={{
 display: 'flex',
 alignItems: 'center',
 gap: '32px'
 }}>
 <a href="#products" style={{
 textDecoration: 'none',
 color: 'var(--text-dark)',
 fontWeight: '500',
 transition: 'color 0.3s ease'
 }} onMouseOver={(e) => e.target.style.color = 'var(--primary)'} onMouseOut={(e) => e.target.style.color = 'var(--text-dark)'}>
产品 </a>
 <a href="#about" style={{
 textDecoration: 'none',
 color: 'var(--text-dark)',
 fontWeight: '500',
 transition: 'color 0.3s ease'
 }} onMouseOver={(e) => e.target.style.color = 'var(--primary)'} onMouseOut={(e) => e.target.style.color = 'var(--text-dark)'}>
关于我们 </a>
 <a href="#contact" style={{
 textDecoration: 'none',
 color: 'var(--text-dark)',
 fontWeight: '500',
 transition: 'color 0.3s ease'
 }} onMouseOver={(e) => e.target.style.color = 'var(--primary)'} onMouseOut={(e) => e.target.style.color = 'var(--text-dark)'}>
联系 </a>
 <button onClick={onCartClick} style={{
 background: 'none',
 border: 'none',
 position: 'relative',
 cursor: 'pointer',
 padding: '8px',
 borderRadius: '8px',
 transition: 'background 0.3s ease'
 }} onMouseOver={(e) => e.target.style.background = 'rgba(255,107,139,0.1)'} onMouseOut={(e) => e.target.style.background = 'none'}>
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
 <circle cx="9" cy="21" r="1"></circle>
 <circle cx="20" cy="21" r="1"></circle>
 <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
 </svg>
 {getCartItemsCount() > 0 && (
 <span style={{
 position: 'absolute',
 top: '0',
 right: '0',
 background: 'var(--primary)',
 color: 'white',
 borderRadius: '50%',
 width: '18px',
 height: '18px',
 fontSize: '12px',
 fontWeight: 'bold',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center'
 }}>
 {getCartItemsCount()}
 </span>
 )}
 </button>
 </nav>
 </div>
 </div>
 </header>
 )
}

export default Header